import { render, staticRenderFns } from "./ChapterTitle.vue?vue&type=template&id=d9bafd0e&scoped=true"
import script from "./ChapterTitle.vue?vue&type=script&lang=js"
export * from "./ChapterTitle.vue?vue&type=script&lang=js"
import style0 from "./ChapterTitle.vue?vue&type=style&index=0&id=d9bafd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bafd0e",
  null
  
)

export default component.exports